/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Outcome_Notes_LabelInputs */

const en_task_outcome_notes_label = /** @type {(inputs: Task_Outcome_Notes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observation`)
};

const pt_br2_task_outcome_notes_label = /** @type {(inputs: Task_Outcome_Notes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observação`)
};

/**
* | output |
* | --- |
* | "Observation" |
*
* @param {Task_Outcome_Notes_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_outcome_notes_label = /** @type {((inputs?: Task_Outcome_Notes_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Outcome_Notes_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_outcome_notes_label(inputs)
	return pt_br2_task_outcome_notes_label(inputs)
});